import { useNavigation } from "@react-navigation/native";
import React, { useState } from "react";
import { Text, TextInput, TouchableOpacity, View } from "react-native";
import { RadioButton } from "react-native-paper";
import { maskCPFCNPJ } from "../../utils/masks";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";
import { If, Then, Else } from "react-if";

const TransferFindUser = (props) => {
  const navigation = useNavigation();

  const [infoToFind, setInfoToFind] = useState("");
  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="transfer.tituloTransferir" />}
        subtitle={<FormattedMessage id="transferfinduser.comoDesejaBuscar" />}
      />

      <View style={styles.content}>
        <View>
          <Text style={styles.txtBuscaUser}>
            {<FormattedMessage id="transferfinduser.buscarUsuario" />}
          </Text>

          <View style={styles.containerRadioBtn}>
            <RadioButton
              value="email"
              status={infoToFind === "email" ? "checked" : "unchecked"}
              onPress={() => setInfoToFind("email")}
            />
            <Text style={styles.lblInput}>
              <FormattedMessage id="transferfinduser.buscarEmail" />
            </Text>
          </View>
          <If condition={infoToFind === "email"}>
            <Then>
              <View style={styles.containerInput}>
                <FormattedMessage id="transferfinduser.digiteEmail">
                  {(placeholder) => (
                    <TextInput
                      style={styles.inputBuscaUser}
                      placeholder={placeholder}
                      value={email}
                      onChangeText={(text) => {
                        setEmail(text);
                      }}
                    />
                  )}
                </FormattedMessage>
              </View>
            </Then>
          </If>

          <View style={styles.containerRadioBtn}>
            <RadioButton
              value="cpfcnpj"
              status={infoToFind === "cpfcnpj" ? "checked" : "unchecked"}
              onPress={() => setInfoToFind("cpfcnpj")}
            />
            <Text style={styles.lblInput}>
              <FormattedMessage id="transferfinduser.buscarCpf" />
            </Text>
          </View>
          <If condition={infoToFind === "cpfcnpj"}>
            <Then>
              <View style={styles.containerInput}>
                <FormattedMessage id="transferfinduser.digiteCpf">
                  {(placeholder) => (
                    <TextInput
                      style={styles.inputBuscaUser}
                      keyboardType="numeric"
                      placeholder={placeholder}
                      value={cpfCnpj}
                      onChangeText={(text) => {
                        setCpfCnpj(maskCPFCNPJ(text));
                      }}
                    />
                  )}
                </FormattedMessage>
              </View>
            </Then>
          </If>
        </View>
        <If condition={email.length === 0 && cpfCnpj.length === 0}>
          <Then>
            <TouchableOpacity
              disabled={true}
              style={[styles.btn, { marginBottom: 20 }]}
            >
              <Text style={styles.textBtn}>
                <FormattedMessage id="transferfinduser.selecioneDestinatario" />
              </Text>
            </TouchableOpacity>
          </Then>
          <Else>
            <TouchableOpacity
              style={[styles.btn, { marginBottom: 20 }]}
              onPress={() =>
                navigation.navigate({
                  name: "ConfirmTransfer",
                  params: {
                    token: props.route.params.token,
                    qtd: props.route.params.qtd,
                    findUserBy: infoToFind,
                    userKey:
                      infoToFind === "email" ? email.toLowerCase() : cpfCnpj,
                  },
                })
              }
            >
              <Text style={styles.textBtn}>
                <FormattedMessage id="transferfinduser.continuar" />
              </Text>
            </TouchableOpacity>
          </Else>
        </If>

        <GoBackButton />
      </View>
    </View>
  );
};

export default TransferFindUser;
